export const organoboron = {
  "1-Cyclopentenylboronic Acid": "OB(C1=CCCC1)O",
  "2-(2-Bromophenyl)-2,3-dihydro-1H-naphtho[1,8-de][1,3,2]diazaborine": "BrC(C=CC=C1)=C1B(N2)NC3=CC=CC4=C3C2=CC=C4",
  "2-(3-Bromophenyl)-2,3-dihydro-1H-naphtho[1,8-de][1,3,2]diazaborine": "BrC1=CC=CC(B(N2)NC3=CC=CC4=C3C2=CC=C4)=C1",
  "2-(4-Bromophenyl)-2,3-dihydro-1H-naphtho[1,8-de][1,3,2]diazaborine": "BrC1=CC=C(C=C1)B(N2)NC3=CC=CC4=CC=CC2=C43",
  "2-Phenylethylboronic Acid": "OB(CCC1=CC=CC=C1)O",
  "Butylboronic Acid": "CCCCB(O)O",
  "Cyclohexylboronic Acid": "OB(C1CCCCC1)O",
  "Cyclopentylboronic Acid": "OB(C1CCCC1)O",
  "Ethylboronic Acid": "CCB(O)O",
  "Hexylboronic Acid": "CCCCCCB(O)O",
  "Isobutylboronic Acid ": "CC(C)CB(O)O",
  "Isopropylboronic Acid": "CC(B(O)O)C",
  "Methylboronic Acid": "CB(O)O",
  "n-Octylboronic Acid": "CCCCCCCCB(O)O",
  "Pentylboronic Acid": "CCCCCB(O)O",
  "Potassium (2-Formylphenyl)trifluoroborate": "F[B-](F)(C1=CC=CC=C1C=O)F.[K+]",
  "Potassium (2-Methoxyphenyl)trifluoroborate": "F[B-](F)(C1=CC=CC=C1OC)F.[K+]",
  "Potassium (3-Cyanophenyl)trifluoroborate": "F[B-](F)(C1=CC=CC(C#N)=C1)F.[K+]",
  "Potassium (3-Methoxyphenyl)trifluoroborate": "F[B-](F)(C1=CC=CC(OC)=C1)F.[K+]",
  "Potassium (3-Nitrophenyl)trifluoroborate": "F[B-](F)(C1=CC=CC([N+]([O-])=O)=C1)F.[K+]",
  "Potassium (4-Cyanophenyl)trifluoroborate": "F[B-](F)(C1=CC=C(C#N)C=C1)F.[K+]",
  "Potassium (4-Methoxyphenyl)trifluoroborate": "F[B-](F)(C1=CC=C(OC)C=C1)F.[K+]",
  "Potassium (Acetoxymethyl)trifluoroborate": "F[B-](F)(COC(C)=O)F.[K+]",
  "Potassium (Bromomethyl)trifluoroborate": "F[B-](F)(CBr)F.[K+]",
  "Potassium (Iodomethyl)trifluoroborate": "F[B-](F)(CI)F.[K+]",
  "Potassium (Methoxymethyl)trifluoroborate": "F[B-](F)(COC)F.[K+]",
  "Potassium [[(tert-Butoxycarbonyl)amino]methyl]trifluoroborate": "F[B-](F)(CNC(OC(C)(C)C)=O)F.[K+]",
  "Potassium 2-Thienyltrifluoroborate": "F[B-](F)(C1=CC=CS1)F.[K+]",
  "Potassium 3-Pyridyltrifluoroborate": "F[B-](F)(C1=CC=CN=C1)F.[K+]",
  "Potassium 4-Pyridyltrifluoroborate": "F[B-](F)(C1=CC=NC=C1)F.[K+]",
  "Potassium Allyltrifluoroborate": "F[B-](F)(CC=C)F.[K+]",
  "Potassium Cyclopropyltrifluoroborate": "F[B-](F)(C1CC1)F.[K+]",
  "Potassium Phenyltrifluoroborate": "F[B-](F)(C1=CC=CC=C1)F.[K+]",
  "Potassium Trifluoro(trifluoromethyl)borate": "FC([B-](F)(F)F)(F)F.[K+]",
  "Potassium Vinyltrifluoroborate": "F[B-](F)(C=C)F.[K+]",
  "Potassium o-Tolyltrifluoroborate": "F[B-](F)(C1=CC=CC=C1C)F.[K+]",
  "Potassium p-Tolyltrifluoroborate": "F[B-](F)(C1=CC=C(C)C=C1)F.[K+]",
  "Propylboronic Acid": "CCCB(O)O",
  "Sodium (Trihydroxy)phenylborate": "O[B-](O)(O)C1=CC=CC=C1.[Na+]",
}